import TagManager, { TagManagerArgs } from 'react-gtm-module';

import { getPodUserInfo } from 'Feature/Common/Common/Actions/Thunks/getPodUserInfo';
import GeneralConfigs from 'Shared/GeneralConfig/GeneralConfigs.Storage';
import useAppDispatch from 'Shared/Store/dispatch/useAppDispatch';

import { DataLayerHandler } from './DataLayerHandler';

const tagManagerArgs: TagManagerArgs = {
  gtmId: 'GTM-K6DWZCRH',
  events: {
    page_view: 'page_view',
    go_to_wepod: 'go_to_wepod',
    error: 'error',
  },
};

const GTMInitializer: React.FunctionComponent = () => {
  TagManager.initialize(tagManagerArgs);

  const dispatch = useAppDispatch();
  const generalConfigs = GeneralConfigs.getInstance();

  const token = localStorage.getItem('token');

  if (token) {
    dispatch(getPodUserInfo()).then((response: any) => {
      if (response?.payload?.userId) {
        DataLayerHandler.addDataLayer({
          user_id: `${response?.payload?.userId}`,
        });

        generalConfigs.setGeneralConfigs([
          {
            label: 'UserId',
            value: response?.payload?.userId,
          },
        ]);
      }
    });
  }

  return <></>;
};

export default GTMInitializer;
